import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid, Link } from '@material-ui/core';
import { Battery90 as BatteryFullIcon, Battery20 as BatteryAlertIcon } from '@material-ui/icons';
import { FHEContainerForm, FHEContainerScroll, FHEItemText, ProductTitle } from 'data/components';
import { Logger } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';

class ZwaveBasicForm extends PureComponent {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        identifier: PropTypes.string,
        homeId: PropTypes.number,
        homeLabel: PropTypes.string,
        type: PropTypes.string,
        batteryLow: PropTypes.number,
        unhandled: PropTypes.number,
        children: PropTypes.object,
        classes: PropTypes.object.isRequired
    };

    static defaultProps = {
        identifier: null,
        homeId: null,
        homeLabel: null,
        type: null,
        batteryLow: null,
        unhandled: null,
        children: null
    };

    componentDidMount() {
        const { profile, history } = this.props;
        const userRight = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('products_zwave_details');
        if (!userRight) {
            Logger.verbose('Redirect to 403');
            return history.replace('/error/403');
        }
    }

    navigateToHomeDetail = () => {
        const { homeId, history } = this.props;
        return history.push({
            pathname: `/${history.environment}/home/detail/${homeId}`
        });
    };

    render() {
        const { theme, identifier, homeId, homeLabel, type, batteryLow, unhandled, children, classes, profile, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        const userRightHomeDetails = profile.get('admin') || userRights.includes('homeDetails');

        return (
            <Fragment>
                <ProductTitle homeLabel={homeLabel} type={type} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.identifier')}
                                    itemContent={identifier ? identifier.match(/.{1,2}/g).join(':') : 'N/A'}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate(`general.showHome`)}
                                    itemTitle={Translator.translate('general.table.column.homeLabel')}
                                    itemContent={
                                        userRightHomeDetails ? (
                                            <Link component="button" onClick={this.navigateToHomeDetail}>
                                                {`#${homeId} ${homeLabel}`}
                                            </Link>
                                        ) : (
                                            `#${homeId} ${homeLabel}`
                                        )
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.type')}
                                    itemContent={Translator.translate(`general.${type}`)}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.batteryLow')}
                                    itemContent=""
                                    iconSimple={
                                        batteryLow === 0 ? (
                                            <BatteryAlertIcon
                                                style={{
                                                    color: theme.palette.error.main,
                                                    transform: 'rotate(90deg)',
                                                    fontSize: '40',
                                                    marginTop: '-10px'
                                                }}
                                            />
                                        ) : (
                                            <BatteryFullIcon
                                                style={{ color: theme.palette.success.main, transform: 'rotate(90deg)', fontSize: '40' }}
                                            />
                                        )
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.unhandled')}
                                    itemContent={unhandled === 1 ? Translator.translate('general.no') : Translator.translate('general.yes')}
                                    classContent={unhandled === 1 ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    {children}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    const homes = state.environments[history.environment].data.Homes.get('list');
    return {
        profile: state.data.user,
        identifier: product.get('identifier'),
        homeId: product.get('homeId'),
        homeLabel: homes.getIn([product.get('homeId').toString(), 'label'], ''),
        type: product.get('type'),
        batteryLow: product.get('batteryLow'),
        unhandled: product.get('unhandled')
    };
}

const styles = theme => ({
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Zwave/BasicForm/index',
        connect(mapStateToProps)(withStyles(styles, { withTheme: true })(ZwaveBasicForm))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Zwave/BasicForm/index.js